import {useEffect} from 'react'
import {Column} from 'react-table'
import {KTCard} from '../../../../../../../../_metronic/helpers'
import {KTable, KTableHeader, KTableLoading} from '../../../../../../components/UI'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {formatDate} from '../../../../../../util/dates'
import {BookingDetailUpload, BookingDetailUploadLog} from '../../../../models/booking.model'
import {getListBulkLoadLogTrayService} from '../../../../services/booking.service'

const TableUploadBookingDetails = ({bookingToShow}: PropsA) => {
  const {data, setData, setPagination, loading, setLoading, pagination} = useKTable()
  const getUploadBookingsDetail = async (bandejaId: string) => {
    try {
      setLoading(true)
      const {data: response} = await getListBulkLoadLogTrayService({
        BandejaId: bandejaId,
        pageNumber: pagination.currentPage,
        size: pagination.perPage,
      })
      if (!response.error) {
        setData(response.data)
        setPagination({
          ...pagination,
          totalResults: response.total,
        })
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  useEffect(() => {
    getUploadBookingsDetail(bookingToShow.Id as any)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage])

  const columns: Column<BookingDetailUploadLog>[] = [
    {
      Header: (props) => <KTableHeader tableProps={props} title='Nro de Fila' size='50px' />,
      accessor: 'NroFila',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Ruc de Compania' />,
      accessor: 'RucCompania',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Ruc de Cliente' />,
      accessor: 'RucCliente',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Site' />,
      accessor: 'Site',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Campamento' />,
      accessor: 'Campamento',
    },
    {
      Header: (props) => (
        <KTableHeader tableProps={props} title='Nomenclatura de Módulo' size='100px' />
      ),
      accessor: 'CodigoModulo',
    },
    {
      Header: (props) => (
        <KTableHeader tableProps={props} title='Nomenclatura de Habitación' size='100px' />
      ),
      accessor: 'CodigoHabitacion',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Nomenclatura de Cama' />,
      accessor: 'CodigoCama',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Fecha de Ingreso' size='200px' />,
      accessor: 'FechaIngreso',
      Cell: ({...props}) => <div>{formatDate(props.row.original.FechaIngreso)}</div>,
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Fecha de Salida' size='200px' />,
      accessor: 'FechaSalida',
      Cell: ({...props}) => <div>{formatDate(props.row.original.FechaSalida)}</div>,
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Tipo Doc. Huésped' />,
      accessor: 'TipoDocHuesped',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Nro Doc. Huésped' />,
      accessor: 'NroDocHuesped',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Ruc de Contrata' />,
      accessor: 'RucContrata',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Tipo Doc. Interlocutor' />,
      accessor: 'TipoDocInterlocutor',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Nro Doc. Interlocutor' />,
      accessor: 'NroDocInterlocutor',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Observaciones' size='400px' />,
      accessor: 'Observaciones',
      Cell: ({...props}) => (
        <div>
          {props.row.original.Observaciones?.split('\n')?.map((line, index) => (
            <div key={index}>{line}</div>
          ))}
        </div>
      ),
    },
  ]

  useEffect(() => {
    // setLoading(loading)
    setLoading(loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  return (
    <>
      <KTCard shadow className='m-5'>
        <KTable data={data} columns={columns} />
        {loading ? <KTableLoading title='Cargando...' /> : null}
      </KTCard>
    </>
  )
}

interface PropsA {
  // show: boolean
  bookingToShow: BookingDetailUpload
}

const TableUploadBookingShowDetailsWrapper = ({bookingToShow}: PropsA) => {
  return (
    <KTableProvider>
      <TableUploadBookingDetails bookingToShow={bookingToShow} />
    </KTableProvider>
  )
}

export {TableUploadBookingShowDetailsWrapper}
